import React, { useContext, useEffect } from "react"
import Section from "@components/section"
import Tasks from "@components/tasks"
import Button from "@components/button"

import CommonContext from "@src/context"
import task1Image from "@images/season1/mh-task1.png"
import task2Image from "@images/season1/mh-task2.png"
import task3Image from "@images/season1/mh-task3.jpg"
import mhBgImage from "@images/mh-bg.jpg"
import mhResultImage from "@images/season1/mh-result.png"

const MonsterHunter = () => {
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(mhBgImage)
  }, [])
  return (
    <div>
      <Section title="比赛回顾">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>SEASON 1 冠军 </td>
              <td>400刀</td>
            </tr>
            <tr>
              <td>晋级队伍</td>
              <td>
                400刀
                <br />
                古代鹿
                <br />
                FLYY
                <br />
                这游戏疯了吧
              </td>
            </tr>
            <tr>
              <td>其他参赛队伍</td>
              <td>
                法兰猫车队
                <br />
                希你波波呀
                <br />
                K.K.
                <br />
                基丝
              </td>
            </tr>
          </tbody>
        </table>
        <a href={mhResultImage} target="_blank">
          <img
            src={mhResultImage}
            className="fluidImage"
            style={{ marginBottom: "30px", marginTop: "30px" }}
          />
        </a>

        <div className="buttonsContainer">
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1oa4y1i7Ce?p=1"
          >
            DAY1 视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1ST4y1u7Gf?p=1"
          >
            DAY2 视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1qi4y147zN?p=1"
          >
            DAY3 视频录像
          </Button>
        </div>
      </Section>

      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>直播时间</td>
              <td>
                5月7日（周四）20 : 00 开始 A组排位赛
                <br />
                5月8日（周五）20 : 00 开始 B组排位赛
                <br />
                5月9日（周六）14 : 00 开始 C组排位赛
                <br />
                5月10日（周日）14 : 00 开始 D组排位赛、公布排位结果
                <br />（ 对竞速前 24 组选手录像进行直播 ）<br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>
                本次比赛采用视频投稿的形式，进行双人组队斗技场竞速赛
                <br />
                需完成全部3个指定任务
                <br />
                根据游戏内任务计时时间，由快到慢依次排序判定结果
                <br />
                （PC、Xbox One、PS4 平台均可参赛）
                <br />
                <br />
                选手交流组队QQ群号：432248303
              </td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>在投稿截止日期前，提交指定斗技场任务的游戏录像</td>
            </tr>
            <tr>
              <td>投稿要求</td>
              <td>
                每个指定任务，需要同时录制两位选手的视角并进行提交
                <br />
                每份录像要求必须录制完整（接受任务 — 任务完成 — 拿到赏金 —
                退出任务）
              </td>
            </tr>
            <tr>
              <td>投稿流程</td>
              <td>
                将录制完整的 6 份视频，以邮箱的形式发送到 wen@gcores.com 中
                <br />
                邮箱标题为“队名”；内容需标注：队名、两位选手的昵称、联系方式（手机号+微信号）；
                <br />
                如视频存在问题，将在 3 日内收到邮件反馈，未收到则默认有效；
                <br />
                投稿时间内可多次提交，以日期最新的有效视频为准。
              </td>
            </tr>
            <tr>
              <td>投稿时间</td>
              <td>4月6日0时 ~ 4月30日0时，过时将不计入最终成绩</td>
            </tr>
            <tr>
              <td>S1资格赛奖励</td>
              <td>
                竞速前四名队伍可获得 SPARK 线上总决赛赛的参赛资格；
                冠军队伍将额外获得 3,000 元的奖金奖励
              </td>
            </tr>
            <tr>
              <td>线上总决赛奖金</td>
              <td>
                冠军 6,000
                <br />
                亚军 3,000
                <br />
                季军 2,000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛任务">
        <Tasks
          tasks={[
            { image: task1Image, title: "斗技大会大师级 01 —— 讨伐猛牛龙" },
            { image: task2Image, title: "斗技大会大师级 03 —— 讨伐迅龙" },
            { image: task3Image, title: "特别活动大师级——讨伐轰龙" },
          ]}
        />
      </Section>
      <Section title="比赛须知">
        <div className="tips">
          <p>
            1. 参赛选手的 ID
            、头像、队伍名称、衣物、携带物品等不得含有违法国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；
          </p>
          <p>
            2.
            参赛选手不得发表违法国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
          </p>
          <p>3. 本次比赛，机核网拥有最终解释权。</p>
        </div>
      </Section>
      <Section title="排名表">
        <div className="tableRank">
          <table>
            <thead>
              <tr>
                <th>排名</th>
                <th>队伍名</th>
                <th>成员</th>
                <th>猛牛龙</th>
                <th>迅龙</th>
                <th>轰龙</th>
                <th>总成绩</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>TBD</td>
                <td>TBD member</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
              </tr>
              <tr>
                <td>1</td>
                <td>TBD</td>
                <td>TBD member</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
                <td>00’00’’00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  )
}

export default MonsterHunter
